const MedicalInfoTags = ({ tags, className = "" }) => (
  <div
    sx={{
      mt: 4,
      p: 3,
      display: "inline-flex",
      gap: 1,
      flexWrap: "wrap",
      background: "#F6F6F6",
      borderRadius: "8px",
    }}
    data-testid="edit-q-medical-tags"
    className={className}
  >
    {tags.map((tag, index) => (
      <div
        key={index}
        sx={{
          py: 1,
          px: 2,
          fontSize: 0,
          lineHeight: "smallerHeading",
          borderRadius: "24px",
          color: "text",
          background: "background",
          whiteSpace: "nowrap",
        }}
      >
        {tag}
      </div>
    ))}
  </div>
)

export default MedicalInfoTags
